import React, { type ComponentProps, type CSSProperties, type ReactElement } from 'react';

import type { Rule as OriginalRule } from '@atlaskit/renderer/nodes';
import { hexToEditorTextPaletteColor } from '@atlaskit/editor-palette/text';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import type { LightNodeProps } from '../LightNodeObserver.ts';

export const Rule = ({
	color,
	localId,
	style,
	weight,
	lightNodeRef,
}: ComponentProps<typeof OriginalRule> & LightNodeProps): ReactElement => {
	if (!isExperimentEnabled('platform_editor_lovability_dividers_attributes')) {
		return <hr ref={lightNodeRef} role="presentation" />;
	}
	const paletteColor = color && (hexToEditorTextPaletteColor(color) ?? color);
	const paletteStyle: CSSProperties | undefined = paletteColor
		? ({ '--custom-palette-color': paletteColor } as CSSProperties)
		: undefined;
	return (
		<hr
			ref={lightNodeRef}
			role="presentation"
			data-color={color || undefined}
			data-local-id={localId || undefined}
			data-style={style || undefined}
			data-weight={weight ?? undefined}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Authored divider color is a runtime palette value.
			style={paletteStyle}
		/>
	);
};
